export default {
    'page.account.accountquery.overview': '帳戶總覽',
    'page.account.accountquery.primaryAccountNumber': '主賬號',
    'page.account.accountquery.code': '客戶編碼',
    'page.account.accountquery.date': '註冊日期',
    'page.account.accountquery.type': '賬戶類型',
    'page.account.accountquery.account': '賬戶總額',
    'page.account.accountquery.cash': '現金總額',
    'page.account.accountquery.credit': '信用總額',
    'page.account.accountquery.frozen': '凍結金額',
    'page.account.accountquery.used': '已用總額',
    'page.account.accountquery.bills': '未付賬單',
    'page.account.accountquery.deduction': '未生成賬單(扣費)',
    'page.account.accountquery.frozenD': '未生成賬單(凍結)',
    'page.account.accountquery.balance': '可用余額',
    'page.account.accountquery.details': '查看物流單費用明細',
    'page.account.accountquery.cashBalance': '現金余額',
    'page.account.accountquery.limit': '信用額度',
    'page.account.accountquery.deductionDetails': '扣費明細',
    'page.account.accountquery.inquiry': '帳單查詢',
    'page.account.accountquery.prepaid': '預付賬戶',
    'page.account.accountquery.period': '賬期賬戶',
    'page.account.accountquery.viewRechargeDetails': '查看充值明細',
    'page.account.accountquery.viewFrozenDetails': '查看凍結明細',
    'page.account.accountquery.search': '查詢',
    'page.account.accountquery.expense': '費用發生時間',
    'page.account.accountquery.datez': '賬單生成日期',
    'page.account.accountquery.billcode': '賬單編號',
    'page.account.accountquery.cycle': '賬單周期',
    'page.account.accountquery.amount': '賬單金額',
    'page.account.accountquery.currency': '幣種',
    'page.account.accountquery.dueDate': '賬單到期付款日',
    'page.account.accountquery.status': '賬單狀態',
    'page.account.accountquery.detailsZ': '賬單詳情',
    'page.account.accountquery.waybillNo': '運單號',
    'page.account.accountquery.weight': '實際重量(g)',
    'page.account.accountquery.volume': '體積重量(g)',
    'page.account.accountquery.volumeZ': '體積(cm)',
    'page.account.accountquery.billingWeight': '計費重量(g)',
    'page.account.accountquery.expenseType': '費用類型',
    'page.account.accountquery.expenseProject': '費用項目',
    'page.account.accountquery.deductionAmount': '扣費金額',
    'page.account.accountquery.products': '產品名稱',
};